import React from "react";
import Logo from "../../assets/user/images/logo.svg";

const About = () => {
  return (
    <div className="container-fluid" style={{ background: "#1d364e" }}>
      <div className="d-flex align-items-center justify-content-center">
        <img src={Logo} width={300} className="mt-3" />
      </div>
      <div className="p-4">
        <h3
          className="text-center"
          style={{ color: "#bfc3cb", fontWeight: "600" }}
        >
          About US
        </h3>
        <p>
          Our management team developed Care-Exchange.com as a free search
          application service to provide people seeking care and/or job
          opportunities with real time care provider listings and updated job
          alerts via email, text or phone. Our strategic recruiting technology
          along with our years of experience and resources has helped thousands
          of consumers find care providers for their loved ones as well as help
          for those searching for a job.
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>Find Care</h4>
        <p>
          Care-Exchange.com is a platform which promotes and facilitates
          connections between persons (clients) seeking care services for their
          loved ones and care providers and caregivers. Start by searching for
          your ideal care provider in your area today!
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>Find Jobs</h4>
        <p>
          Care-Exchange.com is a free job alert and career network that focuses
          on matching employers (Care Providers) to potential applicants (Care
          Staff) through our easy-to-use job search service (Find Jobs). Our
          initiative is to build a free job network that helps put the
          unemployed back to work and/or help others change careers to better
          their lives. Start by joining our Care Staff Registry and searching
          for your ideal dream job today!
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          Post Job Opportunities & Hire Confidently
        </h4>
        <ul>
          <li>Health Care / Nursing</li>
          <li>Caregivers</li>
          <li>Administrative & Office Staff</li>
        </ul>
        <p>
          Our Platform’s Dashboard allows you to find and hire the right person
          for your business
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          Manage Your Hiring from Start to Finish
        </h4>
        <ul>
          <li>Post a Job – Advertise / Job Opportunity Registry</li>
          <li>Find Quality Applicants – Care Staff Registry</li>
          <li>Make Connections with Applicants</li>
          <li>Hire Confidently</li>
        </ul>
      </div>
    </div>
  );
};

export default About;
